import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Tab from './Tab';

class Tabs extends Component {
    static propTypes = {
        children: PropTypes.instanceOf(Array).isRequired,
        activeTab: PropTypes.string,
        onTabChange: PropTypes.func,
    }

    constructor(props) {
        super(props);
        this.state = {
            activeTab: props.activeTab || this.props.children[0].props.label,
        };
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.activeTab != null
            && this.props.activeTab !== prevProps.activeTab
            && this.props.activeTab !== this.state.activeTab
        ) {
            this.setState({ activeTab: this.props.activeTab });
        }
    }

    onClickTabItem = (tab) => {
        if (this.props.onTabChange) {
            this.props.onTabChange(tab);
        }
        if (this.props.activeTab == null) {
            this.setState({ activeTab: tab });
        }
    }

    render() {
        const {
            onClickTabItem,
            props: {
                children,
                activeTab: controlledTab,
            },
            state: {
                activeTab: internalTab,
            }
        } = this;

        const activeTab = controlledTab != null ? controlledTab : internalTab;

        return (
            <div className="tabs">
                <ol className="tab-list">
                    {
                        children.map((child, index) => {
                            const { label } = child.props;
                            return (
                                <Tab
                                    key={index}
                                    activeTab={activeTab}
                                    label={label}
                                    onClick={onClickTabItem}
                                />
                            );
                        })
                    }
                </ol>
                <div className="tab-content">
                    {children.map((child) => {
                        if (child.props.label !== activeTab) return undefined;
                        return child.props.children;
                    })}
                </div>
            </div>
        );
    }
}

export default Tabs;
